import React, { useEffect, useState } from "react";
import { PhoneInput } from "react-international-phone";
import { useDispatch, useSelector } from "react-redux";
import { setAccept, setCheckAccept, setCustomer, setPhone1, setStep } from "../../../Reducer/customerSlice";
import NextPrev from "../../../Helpers/Components/NextPrev";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Components/Handler";
import Modal from "../../../Helpers/Components/Modal";
import { useParams } from "react-router-dom";
import { getCookie } from "../../../Helpers/Utils";

const Registration = (props) => {
    const customer = useSelector((state) => state.customer?.customer);
    const [loading, setLoading] = useState(false)
    const phone1 = useSelector((state) => state.customer?.phone1);
    const dispatch = useDispatch()
    const validPhoneNumber = new RegExp('^[6-9]{1}[0-9]{9}');
    const { id } = useParams()
    const person = getCookie('person')
    const validName = new RegExp('^[A-Za-z\\s]*$');
    const accept = useSelector((state) => state.customer?.accept)
    const checkAccept = useSelector((state) => state.customer?.checkAccept)
    const [open, setOpen] = useState(false);
    const handleChange = (e) => {
        dispatch(setCustomer({ [e.target.name]: e.target.value }))
    }
    const handlePhoneChange = (phone, code, i) => {
        dispatch(setPhone1({ phone: phone || "", code: code || "+91" }))
    }
    const setSteps = () => {
        dispatch(setStep(1))
    }
    const createCustomer = async (dataToBeSent) => {
        const customerCreate = await Handler({ method: "post", url: '/customer/registration', data: dataToBeSent })
        setLoading(false)
        if (customerCreate?.success) {
            setSteps()
            props?.setCustomerId(customerCreate?.data?.customerId)
            if (customerCreate?.data?.exists) {
                toast.error(customerCreate?.message)
            }
        } else {
            toast.error(customerCreate?.message)
        }
    }
    const updateCustomer = async (dataToBeSent) => {
        const customerUpdate = await Handler({ method: "patch", url: `/customer/details/first/update/${props?.customerId}`, data: dataToBeSent })
        setLoading(false)
        if (customerUpdate?.success) {
            if (customerUpdate?.data?.exists) {
                toast.error(customerUpdate?.message)
            }
            dispatch(setStep(1))

        } else {
            toast.error(customerUpdate?.message)
        }
    }
    const handleNext = async () => {
        if ((!customer?.firstName)) {
            toast.error("First Name is required");
        } 
        // else if ((!validName.test(customer?.firstName))) {
        //     toast.error("Invalid First Name");
        // } 
        else if (!customer?.lastName) {
            toast.error("Last name is required")
        } 
        // else if ((!validName.test(customer?.lastName))) {
        //     toast.error("Invalid Last Name");
        // } 
        else if (!phone1?.phone) {
            toast.error("Phone number is required");
        } else if ((phone1?.code === "+91" || phone1?.code === "91") && !validPhoneNumber.test(phone1?.phone)) {
            toast.error("Phone number is Invalid");
        } else {
            let dataToBeSent = {
                type: customer?.type,
                custType: customer?.custType,
                firstName: customer?.firstName,
                phone: [{ phone: phone1?.phone, priority: 1, type: 'normal', code: phone1?.code }],
                lastName: customer?.lastName,
            }
            setLoading(true);
            if (props?.customerId) {
                // const response = await Handler({ method: "post", url: '/customer/check/number', data: { phone: phone1?.phone } })
                // if (response?.success) {
                //     if (response?.data?.exist && !accept) {
                //         setLoading(false)
                //         setOpen(true)
                //     } else {
                dispatch(setAccept(true))
                updateCustomer(dataToBeSent)
                //     }
                // } else {
                //     setLoading(false)
                //     toast.error(response?.message)
                // }
            } else {
                setLoading(true)
                // const response = await Handler({ method: "post", url: '/customer/check/number', data: { phone: phone1?.phone } })
                // if (response?.success) {
                //     if (response?.data?.exist && !accept) {
                //         setLoading(false)
                //         setOpen(true)
                //     } else {
                dispatch(setAccept(true))
                createCustomer(dataToBeSent)
                //     }
                // } else {
                //     setLoading(false)
                //     toast.error(response?.message)
                // }
            }
        }
    }
    useEffect(() => {
        if (accept && checkAccept) {
            dispatch(setCheckAccept(false))
            handleNext()
        }
    }, [accept, checkAccept])
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-sm-6 col-md-4 col-lg-6">
                    <div className="mb-3">
                        <label htmlFor="type" className="form-label"> Type </label>
                        <div className="d-flex gap-4">
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="type" id="Online" checked={customer?.type === "Online"} onChange={(e) => { if (e.target.checked) { dispatch(setCustomer({ type: "Online" })) } }} />
                                <label className="form-check-label" htmlFor="Online">
                                    Online
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="type" id="Offline" checked={customer?.type === "Offline"} onChange={(e) => { if (e.target.checked) { dispatch(setCustomer({ type: "Offline" })) } }} />
                                <label className="form-check-label" htmlFor="Offline">
                                    Offline
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-6">
                    <div className="mb-3">
                        <label htmlFor="name" className="form-label"> Cust Type </label>
                        <div className="d-flex gap-4">
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="custType" id="local" checked={customer?.custType === "local"} onChange={(e) => { if (e.target.checked) { dispatch(setCustomer({ custType: "local" })) } }} />
                                <label className="form-check-label" htmlFor="local">
                                    Local
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="custType" id="nri" checked={customer?.custType === "nri"} onChange={(e) => { if (e.target.checked) { dispatch(setCustomer({ custType: "nri" })) } }} />
                                <label className="form-check-label" htmlFor="nri">
                                    NRI
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="custType" id="foreigner" checked={customer?.custType === "foreigner"} onChange={(e) => { if (e.target.checked) { dispatch(setCustomer({ custType: "foreigner" })) } }} />
                                <label className="form-check-label" htmlFor="foreigner">
                                    Foreigner
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-6 col-xl-4">
                    <div className="mb-3">
                        <label htmlFor="firstName" className="form-label"> First Name </label>
                        <input autoComplete="off" disabled={loading} id="firstName" type="text" name="firstName" value={customer?.firstName || ""} onChange={handleChange} className="form-control input-theme text-uppercase" />
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-6 col-xl-4">
                    <div className="mb-3">
                        <label htmlFor="lastName" className="form-label"> Last Name </label>
                        <input autoComplete="off" disabled={loading} id="lastName" type="text" name="lastName" value={customer?.lastName || ""} onChange={handleChange} className="form-control input-theme text-uppercase" />
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-6 col-xl-4">
                    <div className="mb-3">
                        <label htmlFor="phone1" className="form-label"> Phone </label>
                        <PhoneInput
                            defaultCountry="in"
                            disabled={loading || phone1?.status || phone1?.load || (person !== "admin" && id)}
                            value={phone1?.phone ? phone1?.code + phone1?.phone : ""}
                            onChange={(phone1, metadata) => {
                                const code = `+${metadata.country.dialCode}`;
                                const phone = phone1.replace(code, "").replace(/\s/g, "").replace(/-/g, "");
                                handlePhoneChange(phone, code, 1)
                            }}
                            onPaste={(e) => {
                                e.preventDefault();
                                let pasteData = e.clipboardData.getData('Text');
                                pasteData = pasteData.replace(/\D/g, '').slice(0, 10);
                                dispatch(setPhone1({ phone: pasteData, code: e[0] }))
                            }}
                        />
                    </div>
                </div>
            </div>
            <NextPrev step={0} setStep={setSteps} last={7} onClick={handleNext} loading={loading} />
            <Modal header="Customer Already Exists in Customer Table" onShow={open} toggle={() => setOpen(false)} overlayToggle={() => setOpen(false)}>
                <div>Really Wanna add this customer ? </div>
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-sm btn-success" onClick={() => { dispatch(setAccept(true)); setOpen(false); setCheckAccept(true) }}>Accept</button><button className="btn btn-sm btn-danger" onClick={() => { dispatch(setAccept(false)); setOpen(false); }}>Reject</button>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default Registration;